import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  calendar: {
    paddingTop: '1rem',
  },
})
